import Vue from "vue";
import {
  Button,
  Input,
  Form,
  Icon,
  Select,
  TimePicker,
  Spin,
  Carousel,
  Row,
  Col
} from "ant-design-vue";
import { LocaleProvider } from "ant-design-vue";
Vue.component(LocaleProvider.name, LocaleProvider);
Vue.component(Button.name, Button);
Vue.component(Input.name, Input);
Vue.component(Input.Group.name, Input.Group);
Vue.component(Input.Search.name, Input.Search);
Vue.component(Form.name, Form);
Vue.component(Form.Item.name, Form.Item);
Vue.component(Icon.name, Icon);
Vue.component(Select.name, Select);
Vue.component(Select.Option.name, Select.Option);
Vue.component(TimePicker.name, TimePicker);
Vue.component(Spin.name, Spin);
Vue.component(Carousel.name, Carousel);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
